﻿import Swiper from '../lib/Swiper/swiper-bundle.esm.browser.min.js'
import News from './News.js'
import Like from './Like.js'
import Poll from './Poll.js'
import NewsSeen from './NewsSeen.js'
import Comment from './Comment.js'
import {
  collapse,
  containsHTML,
  expand,
  getDisplayDate,
  getIframe,
  getThumbnailURL,
  isNullOrWhitespace
} from '../../util.js'
import { editNews, unpublishNews, PAYLOAD, createImgModal, USER, handleLike, showStats } from '../home.js'
import dayjs from '../lib/dayjs.min.js'

const home = document.querySelector('.page-home')

export class SingleNews extends window.HTMLElement {
  constructor() {
    super()

    this.attachShadow({ mode: 'open' })
    const template = document.querySelector('#single-news-wrapper')
    this.shadowRoot.appendChild(template.content.cloneNode(true))
  }

  connectedCallback() {
    this.setVariables()
    this.setHeight()
    this.setNews()
    this.getComments()
    this.addEventListeners()
    this.addAutoResize()
    this.handleSeen()
    this.slideIn()
  }

  setVariables() {
    this._interactable = this.dataset.interactable
    this._hasSeen = this.dataset.hasSeen
    this._ID = this.dataset.id

    this._container = this.shadowRoot.querySelector('#single-news-container')
    this._btnBackSingleNews = this.shadowRoot.querySelector('#btn-back-single-news')
    this._author = this.shadowRoot.querySelector('.single-news-author')
    this._btnNewsOptions = this.shadowRoot.querySelector('.single-news-btn-options')
    this._optionsInner = this.shadowRoot.querySelector('.single-news-options-inner')
    this._closeOptions = this.shadowRoot.querySelector('.single-news-options-close')
    this._del = this.shadowRoot.querySelector('.single-news-delete')
    this._pollTitle = this.shadowRoot.querySelector('.single-news-poll-title')
    this._title = this.shadowRoot.querySelector('.single-news-title')
    this._created = this.shadowRoot.querySelector('.single-news-created')
    this._to = this.shadowRoot.querySelector('.single-news-to-full')
    this._content = this.shadowRoot.querySelector('.single-news-content')
    this._links = this.shadowRoot.querySelector('.single-news-links')
    this._edit = this.shadowRoot.querySelector('.single-news-edit.option')
    this._stats = this.shadowRoot.querySelector('.single-news-stats.option')
    this._poll = this.shadowRoot.querySelector('.single-news-poll')
    this._imgWrap = this.shadowRoot.querySelector('.image-wrap')
    this._btnLike = this.shadowRoot.querySelector('.single-news-btn-like')
    this._likes = this.shadowRoot.querySelector('.single-news-likes span')
    this._commentWrap = this.shadowRoot.querySelector('.comment-wrap')
    this._commentInputWrap = this.shadowRoot.querySelector('#comment-input-wrap')
    this._commentInput = this._commentInputWrap.querySelector('textarea')
    this._commentBtn = this._commentInputWrap.querySelector('#btn-comment')

    this._news = ''
    this._newsInList = ''
    this._payloadNews = ''

    if (this._interactable === 'false') {
      this.shadowRoot.querySelector('.single-news-btn-wrap')?.remove()
      this.shadowRoot.querySelector('.social-wrap')?.remove()
      this._commentInputWrap.remove()
    }
  }

  getComments() {
    window
      .fetch('/HR/api/getcomments.aspx', {
        method: 'POST',
        body: this._ID,
        headers: {
          'Content-Type': 'text/plain'
        }
      })
      .then((res) => res.json())
      .then((data) => {
        if (data.length !== 0) {
          this._commentWrap.innerHTML = ''

          for (let i = 0; i < data.length; i++) {
            const comment = new Comment(data[i])

            this.createCommentElement(comment)
          }
        }

        this.checkIfComment()
      })
      .catch((err) => console.error(err))
  }

  async setNews() {
    this._payloadNews = PAYLOAD.find((x) => x.ID === Number(this._ID))
    this._news = new News(this._payloadNews)
    this._newsInList = document.querySelector(`.single-news[data-id='${this._ID}']`)
    console.log(this._newsInList)
    this._news.Videos = JSON.parse(this._news.Videos)
    this._news.Links = JSON.parse(this._news.Links)

    const notPublished = dayjs(this._news.Created).isAfter(dayjs()) // if created is after today

    if (notPublished) {
      this.shadowRoot.querySelector('.single-news-btn-wrap')?.remove()
      this.shadowRoot.querySelector('.social-wrap')?.remove()
      this._commentWrap.remove()
      this._commentInputWrap.remove()
      this.shadowRoot.querySelector('.single-news-delete.option').textContent = lang_remove_post
      this.shadowRoot.querySelector('.single-news').classList.add('not-published')
    }

    if (this._news.Author !== '0') {
      this._author.textContent = `${lang_posted_by}: ${this._news.Author}`
    } else {
      this._author.remove()
    }

    if (USER.Admin !== true) {
      if (this._news.UserIDRef !== USER.UserID) {
        this._btnNewsOptions.remove()
      }
    }

    this._title.textContent = this._news.Title
    this._created.textContent = notPublished
      ? `${lang_publishes}: ${getDisplayDate(this._news.Created)}`
      : getDisplayDate(this._news.Created)
    this._to.textContent = this._news.Groups.filter((x) => !x.isExcluded)
      .map((x) => x.groupName)
      .join(', ')
    this._content.innerHTML = this._news.Contents

    this._content.querySelectorAll('a').forEach((a) => {
      a.setAttribute('target', '_blank')
    })

    containsHTML(this._news.Contents) ? this._content.classList.add('is-html') : this._content.classList.add('pre-wrap')

    for (let i = 0; i < this._news.Links.length; i++) {
      const name = this._news.Links[i].Name
      const URL = this._news.Links[i].URL

      const a = document.createElement('a')
      a.innerHTML = `
        <a href=${URL} target='_blank'>
        <i class="fas fa-link"></i>${name}
        </a>
      `

      this._links.appendChild(a)
    }

    if (this._news.Poll !== '{}' && !isNullOrWhitespace(this._news.Poll)) {
      await this.createPoll()
    } else {
      this._pollTitle.classList.add('hidden')
    }

    const mediaLength = this._news.Images.length + this._news.Videos.length

    this._imgWrap.style.display = 'none'

    if (mediaLength !== 0) {
      if (mediaLength === 1) {
        if (this._news.Images.length) {
          const img = document.createElement('img')

          img.onload = () => {
            this._imgWrap.appendChild(img)
            this._imgWrap.style.display = 'block'

            img.addEventListener('click', () => {
              createImgModal(img)
            })
          }

          img.src = `/FILEARCHIVE/${this._news.Images[0].Src}`
        } else if (this._news.Videos.length) {
          const vid = this._news.Videos[0]
          const thumbnailURL = getThumbnailURL(vid.Type, vid.URL)

          const img = document.createElement('img')

          img.onload = () => {
            this._imgWrap.classList.add('is-video')
            this._imgWrap.appendChild(img)
            this._imgWrap.style.display = 'block'
            img.dataset.iframe = getIframe(vid.Type, vid.URL).innerHTML

            img.addEventListener('click', () => {
              createImgModal(img)
            })
          }

          img.src = thumbnailURL
        }
      } else {
        const swiperDiv = document.createElement('div')
        swiperDiv.classList = 'swiper'

        const swiperWrapper = document.createElement('div')
        swiperWrapper.classList = 'swiper-wrapper'

        const imgs = []
        let jcount = 0

        for (let j = 0; j < this._news.Images.length; j++) {
          const swiperSlide = document.createElement('div')
          swiperSlide.classList = 'swiper-slide'

          const img = document.createElement('img')

          img.onload = () => {
            img.dataset.index = jcount
            swiperSlide.appendChild(img)
            swiperWrapper.appendChild(swiperSlide)
          }

          img.src = `/FILEARCHIVE/${this._news.Images[j].Src}`
          imgs.push(img)

          jcount++
        }

        for (let j = 0; j < this._news.Videos.length; j++) {
          const swiperSlide = document.createElement('div')
          swiperSlide.classList = 'swiper-slide is-video'

          const vid = this._news.Videos[j]
          const thumbnailURL = getThumbnailURL(vid.Type, vid.URL)

          const img = document.createElement('img')

          img.onload = () => {
            img.dataset.iframe = getIframe(vid.Type, vid.URL).innerHTML
            img.dataset.index = jcount
            swiperSlide.appendChild(img)
            swiperWrapper.appendChild(swiperSlide)
          }

          img.src = thumbnailURL
          imgs.push(img)
          jcount++
        }

        swiperDiv.appendChild(swiperWrapper)

        for (let j = 0; j < imgs.length; j++) {
          imgs[j].addEventListener('click', () => {
            createImgModal(imgs[j], swiperDiv)
          })
        }

        this._imgWrap.appendChild(swiperDiv)

        setTimeout(() => {
          this._imgWrap.style.display = mediaLength === 0 ? 'none' : 'block'
        }, 300)

        const sw = this.shadowRoot.querySelector('.swiper')

        // eslint-disable-next-line
        new Swiper(sw, {
          slidesPerView: 1.2,
          spaceBetween: 10
        })
      }
    }

    if (this._interactable === 'true') {
      this._likes.textContent = `${this._news.Likes} ${lang_likes_this}`

      if (this._newsInList.querySelector('.single-news-btn-like').classList.contains('active')) {
        this._btnLike.classList.add('active')
      }
    }
  }

  addEventListeners() {
    this._edit.addEventListener('click', () => {
      editNews(Number(this._ID))
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
      this.slideOutAndDelete()
    })

    this._del.addEventListener('click', () => {
      unpublishNews(Number(this._ID))
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
      this.slideOutAndDelete()
    })

    this._stats.addEventListener('click', () => {
      showStats(Number(this._ID))
      this.slideOutAndDelete()
    })

    this._btnBackSingleNews.addEventListener('click', () => {
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
      this.slideOutAndDelete()
    })

    this.shadowRoot.addEventListener('click', (e) => {
      const isClickInside = this._optionsInner.contains(e.target)
      const isClickInsideBtn = this._btnNewsOptions.contains(e.target)
      const optionsIsOpen = this._optionsInner.getAttribute('data-collapsed') === 'false'

      if (!isClickInside && optionsIsOpen && !isClickInsideBtn) {
        collapse(this._optionsInner)
      }
    })

    this._btnNewsOptions.addEventListener('click', () => {
      const optionsIsOpen = this._optionsInner.getAttribute('data-collapsed') === 'false'
      optionsIsOpen ? collapse(this._optionsInner) : expand(this._optionsInner)
    })

    this._closeOptions.addEventListener('click', () => {
      collapse(this._optionsInner)
    })

    if (this._interactable === 'true') {
      this._commentBtn.addEventListener('click', () => {
        this.createComment()
      })

      this._btnLike.addEventListener('click', () => {
        this._btnLike.classList.toggle('active')

        const like = new Like()
        like.UserIDRef = USER.UserID
        like.NewsRef = Number(this._ID)
        like.UserName = `${USER.FirstName} ${USER.LastName}`
        like.Created = dayjs().format()

        const likeBtnInList = this._newsInList.querySelector('.single-news-btn-like')
        const likeNmbrInList = this._newsInList.querySelector('.single-news-likes span')

        if (this._btnLike.classList.contains('active')) {
          this._payloadNews.Likes++
          this._likes.textContent = `${this._payloadNews.Likes} ${lang_likes_this}`
          likeNmbrInList.textContent = `${this._payloadNews.Likes} ${lang_likes_this}`
          likeBtnInList.classList.add('active')
        } else {
          this._payloadNews.Likes--
          this._likes.textContent = `${this._payloadNews.Likes} ${lang_likes_this}`
          likeNmbrInList.textContent = `${this._payloadNews.Likes} ${lang_likes_this}`
          likeBtnInList.classList.remove('active')
        }

        handleLike(like)
      })
    }
  }

  handleSeen() {
    if (this._hasSeen === 'true') {
      return
    }

    const newsSeen = new NewsSeen()
    newsSeen.NewsRef = this._ID
    newsSeen.UserIDRef = USER.UserID
    newsSeen.UserName = `${USER.FirstName} ${USER.LastName}`
    newsSeen.TimeSeen = dayjs().format()

    window
      .fetch('/HR/api/createhasseen.aspx', {
        method: 'POST',
        body: JSON.stringify(newsSeen),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        if (res.status === 200) {
          this._payloadNews.UserHasSeen = true
          this._newsInList.dataset.hasSeen = 'true'
          this._newsInList.querySelector('.single-news-read')?.remove()
        }
      })
      .catch((err) => console.error(err))
  }

  createComment() {
    if (!isNullOrWhitespace(this._commentInput.value)) {
      const comment = new Comment()
      comment.NewsRef = Number(this._ID)
      comment.Contents = this._commentInput.value
      comment.UserIDRef = USER.UserID
      comment.Created = dayjs().format()
      comment.UserName = `${USER.FirstName} ${USER.LastName}`
      comment.UserInitials = USER.FirstName.charAt(0) + USER.LastName.charAt(0)

      window
        .fetch('/HR/api/createcomment.aspx', {
          method: 'POST',
          body: JSON.stringify(comment),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then((res) => {
          if (res.status === 200) {
            return res.text()
          }
        })
        .then((id) => {
          comment.ID = Number(id)

          this.createCommentElement(comment)

          const commentSpan = this._newsInList.querySelector('.single-news-comments span')
          const currentComments = Number(commentSpan.textContent.match(/\d+/g)[0])
          this._commentInput.value = ''
          commentSpan.textContent =
            currentComments === 0
              ? `${currentComments + 1} ${lang_a_comment}`
              : `${currentComments + 1} ${lang_comments}`
          this._payloadNews.Comments++

          this._container.scrollTop = this._container.scrollHeight
        })
        .catch((err) => console.error(err))
    }
  }

  /**
   *
   * @param {Comment} comment
   */
  createCommentElement(comment) {
    const commentDiv = document.createElement('div')
    commentDiv.classList = 'single-comment'

    const signature = document.createElement('div')
    signature.classList = 'single-comment-signature'
    signature.innerHTML = comment.UserInitials

    const name = document.createElement('p')
    name.classList = 'single-comment-name'
    name.textContent = comment.UserName

    const wrap = document.createElement('div')
    wrap.classList = 'single-comment-wrap'

    const content = document.createElement('div')
    content.classList = 'single-comment-content'
    content.textContent = comment.Contents

    const created = document.createElement('div')
    created.classList = 'single-comment-created'

    const createdText = document.createElement('p')

    const time = dayjs(comment.Created).fromNow(true)
    createdText.textContent = time

    const createdTextFull = document.createElement('p')
    createdTextFull.classList = 'full-date'
    createdTextFull.textContent = getDisplayDate(comment.Created)

    const edit = document.createElement('div')
    edit.classList = 'single-comment-edit'

    const editWrap = document.createElement('div')
    editWrap.classList = 'edit-wrap'

    const removeText = document.createElement('p')
    removeText.classList = 'active'
    removeText.textContent = lang_remove_comment

    const iconWrap = document.createElement('div')
    iconWrap.classList = 'icon-wrap'

    const removeComment = document.createElement('i')
    removeComment.classList = 'fas fa-check'

    const times = document.createElement('i')
    times.classList = 'fas fa-times'

    const close = document.createElement('div')
    close.classList.add('close-edit-comment')

    const times2 = document.createElement('i')
    times2.classList = 'fas fa-times'

    iconWrap.appendChild(removeComment)
    iconWrap.appendChild(times)

    editWrap.appendChild(removeText)
    editWrap.appendChild(iconWrap)
    close.appendChild(times2)
    edit.appendChild(editWrap)
    edit.appendChild(close)

    commentDiv.appendChild(signature)
    wrap.appendChild(name)
    wrap.appendChild(content)
    commentDiv.appendChild(wrap)
    created.appendChild(createdText)
    created.appendChild(createdTextFull)
    commentDiv.appendChild(created)
    commentDiv.appendChild(edit)

    this._commentWrap.appendChild(commentDiv)

    commentDiv.addEventListener('click', (e) => {
      if (comment.UserIDRef !== USER.UserID) return

      if (!edit.contains(e.target) && !created.contains(e.target)) {
        commentDiv.classList.add('hide-content')
        edit.classList.add('active')
      }
    })

    removeComment.addEventListener('click', () => {
      comment.Deleted = 'true'

      window
        .fetch('/HR/api/createcomment.aspx', {
          method: 'POST',
          body: JSON.stringify(comment),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then((res) => {
          if (res.status === 200) {
            const commentSpan = this._newsInList.querySelector('.single-news-comments span')
            const currentComments = Number(commentSpan.textContent.match(/\d+/g)[0])

            commentSpan.textContent =
              currentComments === 1 ? `${currentComments - 1} kommentar` : `${currentComments - 1} kommentarer`
            this._payloadNews.Comments--
            commentDiv.remove()
          }
        })
        .catch((err) => console.error(err))
    })

    times.addEventListener('click', () => {
      removeText.classList.add('active')
      iconWrap.classList.remove('active')
    })

    times2.addEventListener('click', () => {
      commentDiv.classList.remove('hide-content')
      edit.classList.remove('active')
      removeText.classList.add('active')
      iconWrap.classList.remove('active')
    })

    removeText.addEventListener('click', () => {
      removeText.classList.remove('active')
      iconWrap.classList.add('active')
    })

    this.shadowRoot.addEventListener('click', (e) => {
      const isClickInside = commentDiv.contains(e.target)
      const editIsActive = edit.classList.contains('active')
      const isClickOnTime = created.contains(e.target)

      if (!isClickInside && editIsActive && !isClickOnTime) {
        commentDiv.classList.remove('hide-content')
        edit.classList.remove('active')
        removeText.classList.add('active')
        iconWrap.classList.remove('active')
      }
    })
  }

  async createPoll() {
    const poll = new Poll(JSON.parse(this._news.Poll))

    const pollHasEnded = dayjs(poll.endDate).isBefore(dayjs())

    if (pollHasEnded) {
      this._pollTitle.querySelector('span').textContent = lang_finished_poll
      this._pollTitle.classList.add('ended')
    } else {
      this._pollTitle.querySelector('span').textContent = lang_ongoing_poll
    }

    const wrapper = document.createElement('div')
    wrapper.classList = 'poll__wrapper'

    const question = document.createElement('p')
    question.classList = 'poll__question'
    question.textContent = poll.question

    wrapper.appendChild(question)

    const answerWrapper = document.createElement('div')
    answerWrapper.classList = 'poll__answer-wrapper'

    const res = await window.fetch(`/HR/api/pollvote.aspx?news-id=${this._news.ID}`)
    const answerData = await res.json()

    const userVote = answerData.find((x) => x.NewsId === this._news.ID && x.UserId === USER.UserID)
    const userHasVoted = userVote !== undefined

    for (let i = 0; i < poll.answers.length; i++) {
      const wrap = document.createElement('div')
      wrap.classList = 'poll__single-answer-wrapper'

      if (!pollHasEnded && !userHasVoted) {
        const input = document.createElement('input')
        input.type = poll.multipleAnswers === 'true' ? 'checkbox' : 'radio'
        input.name = 'poll-answer'
        input.value = poll.answers[i]
        input.id = `poll-answer-${i}`
        input.dataset.index = i

        const label = document.createElement('label')
        label.setAttribute('for', `poll-answer-${i}`)
        label.textContent = poll.answers[i]

        wrap.appendChild(input)
        wrap.appendChild(label)
      } else {
        const answer = document.createElement('div')
        answer.classList = 'poll__answer'
        answer.textContent = poll.answers[i]
        answer.dataset.index = i

        if (userHasVoted && userVote.Answers.filter((x) => x.AnswerId === i).length > 0) {
          answer.classList.add('poll__answer-active')
        }

        wrap.appendChild(answer)
      }

      answerWrapper.appendChild(wrap)
    }

    wrapper.appendChild(answerWrapper)

    const errorText = document.createElement('p')
    errorText.classList = 'poll__error-text hidden'
    errorText.textContent = lang_choose_option

    wrapper.appendChild(errorText)

    const thanks = document.createElement('p')
    thanks.classList = 'poll__vote-thanks hidden'
    thanks.textContent = lang_thank_you_vote
    wrapper.appendChild(thanks)

    if (userHasVoted) {
      thanks.classList.remove('hidden')
    }

    if (!pollHasEnded && !userHasVoted) {
      const voteButton = document.createElement('div')
      voteButton.classList = 'button-round blue'
      voteButton.textContent = lang_vote

      voteButton.addEventListener('click', () => {
        const answers = [...answerWrapper.querySelectorAll('input')]
          ?.filter((x) => x.checked)
          ?.map((x) => {
            return {
              AnswerId: x.dataset.index,
              AnswerText: x.value
            }
          })

        answers.length === 0 ? errorText.classList.remove('hidden') : errorText.classList.add('hidden')

        if (answers.length === 0) {
          return
        }

        const obj = {
          NewsId: this._news.ID,
          UserId: USER.UserID,
          Answers: answers
        }

        voteButton.remove()
        thanks.classList.remove('hidden')

        const voteBtn = this._newsInList.querySelector('.button-round.blue')

        voteBtn?.insertAdjacentElement('afterend', thanks)
        voteBtn?.remove()

        this._newsInList.querySelectorAll('.poll__single-answer-wrapper input').forEach((i) => {
          if (answers.filter((x) => x.AnswerId === i.dataset.index).length !== 0) {
            i.checked = 'true'
          }
        })

        window
          .fetch('/HR/api/pollvote.aspx', {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((res) => res.text())
          .then((data) => {})
          .catch((err) => {
            console.error(err)

            thanks.classList = 'poll__vote-err'
            thanks.textContent = lang_something_went_wrong
          })
      })

      wrapper.appendChild(voteButton)
    }

    const infoText = document.createElement('p')
    infoText.classList = 'poll__info-text'
    infoText.textContent = pollHasEnded
      ? lang_poll_ended
      : `${lang_poll_ends} ${getDisplayDate(poll.endDate).toLowerCase()}`

    wrapper.appendChild(infoText)

    if (userHasVoted || pollHasEnded) {
      const votes = answerData.map((x) => x.Answers.map((y) => y.AnswerId)).flat()
      this.setupPollStats(poll, votes, wrapper)
    }

    this._poll.appendChild(wrapper)
  }

  setupPollStats(poll, votes, wrapper) {
    if (
      this._news.UserIDRef !== USER.UserID &&
      (poll.visible === 'false' || votes.length === 0) &&
      poll?.visiblePollEnded === 'false'
    ) {
      return
    }

    const totalVotes = votes.length
    const uniqueAlternatives = [...new Set(votes)]

    uniqueAlternatives.forEach((alt) => {
      const numItems = votes.filter((v) => v === alt)
      const percentage = Math.round((numItems.length * 100) / totalVotes)

      const altEl = wrapper.querySelector(`.poll__answer[data-index="${alt}"]`)

      if (!altEl.classList.contains('poll__answer-active')) {
        altEl.classList.add('poll__answer-active--grey')
      }

      const span = document.createElement('span')
      span.textContent = `${percentage}%`
      span.classList = 'poll__percentage'

      altEl.style.backgroundSize = `${percentage}%`

      altEl.appendChild(span)
    })

    const noneVotedAlts = this._poll.querySelectorAll(
      '.poll__answer:not(.poll__answer-active--grey):not(.poll__answer-active)'
    )

    noneVotedAlts.forEach((alt) => {
      const span = document.createElement('span')
      span.textContent = '0%'
      span.classList = 'poll__percentage'

      alt.appendChild(span)
      alt.style.backgroundSize = '0%'
    })

    if (this._news.UserIDRef === USER.UserID && poll.visible === 'false') {
      const pollHasEnded = dayjs(poll.endDate).isBefore(dayjs())

      if (pollHasEnded && poll.visiblePollEnded === 'true') {
        return
      }

      const target = this.shadowRoot.querySelector('.poll__answer-wrapper')

      const info = document.createElement('p')
      info.classList = 'poll__visibility-info'
      info.textContent = lang_result_only_visible_to_you

      target.insertAdjacentElement('afterend', info)
    }
  }

  setHeight() {
    this._container.style.height = this.offsetHeight + 'px'
  }

  checkIfComment() {
    if (this.dataset.focusInput === 'true') {
      this._commentInput.focus()
      this._container.scrollTop = this._container.scrollHeight
    }
  }

  slideIn() {
    Promise.allSettled([window.customElements.whenDefined('single-news')]).then(() => {
      this.classList.add('active')
      this.shadowRoot.querySelector('#comment-input-wrap')?.classList.add('active')
    })
  }

  slideOutAndDelete() {
    this.classList.remove('active')
    this._commentInputWrap.classList.remove('active')

    setTimeout(() => {
      this.remove()
    }, 400)
  }

  addAutoResize() {
    const offset = this._commentInput.offsetHeight - this._commentInput.clientHeight
    this._container.style.paddingBottom = 59 + 'px'

    this._commentInput.addEventListener('input', (e) => {
      e.target.style.height = 'auto'
      e.target.style.height = e.target.scrollHeight + offset + 'px'
      this._container.style.paddingBottom = this._commentInputWrap.offsetHeight + 'px'
      this._container.scrollTop = this._container.scrollHeight
    })
  }
}

// Define custom element
window.customElements.define('single-news', SingleNews)
